module.exports = __webpack_public_path__ + "img/steamBarrier.17790c1c.png";